module.exports = __webpack_public_path__ + "static/media/successIndicator.a5fbe3a2.svg";